import {useSelector} from 'react-redux';

// Utils
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {hotelRulesDisclaimer} from '@stencil/hotels-config/src/constants/common';

// Selectors
import {
  checkInTimeFromMetaInfo,
  checkOutTimeFromMetaInfo,
  staticDataSelector,
  isAltAccoSelector,
  hotelDetailsSelector,
  checkOutTimeV2Selector,
  checkInTimeV2Selector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

// HOOKS
import {BaseColumnWrap} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// ICONS
// import CheckedIcon from '../../../../../stories/Icons/CheckedIcon';

// COMPONENTS
import HouseRules from './HouseRules/HouseRules';

// STYLES
import * as S from './Policy.styles';

const Policy = () => {
  // const {hotelPolicyList, hotelPolicyError, hotelPolicyFetchStatus} = useSelector(
  //   hotelPolicyDataSelector,
  // );

  const {searchRoomRequestState} = useSelector(staticDataSelector);

  const hotelDetails = useSelector(hotelDetailsSelector);
  const checkInTime = useSelector(checkInTimeV2Selector) || '';
  const checkoutTime = useSelector(checkOutTimeV2Selector) || '';
  const isAltAcco = useSelector(isAltAccoSelector) || '';

  const checkInTimeForNonAltAcco = useSelector(checkInTimeFromMetaInfo);
  const checkOutTimeForNonAltAcco = useSelector(checkOutTimeFromMetaInfo);

  const haveFlexibleCheckinRules = hotelDetails?.flexibleCheckin?.rules?.length > 0;

  // const isHermesEntirePropertyPropInfo = useSelector(isHermesEntirePropertyPropInfoSelector);

  /** review page also needs hotel policy, we get pax from there
   *  when this function will be fired from there. Keeping it static
   * for nowb.
  // const descblock = {input: {pax: ''}};
  // const {input = {pax: ''}} = descblock;
  // const {pax: paxFromDescblock = ''} = input;

  /**
   * we have to use the old format of pax (the one which hermes sends back in room flavors)
   *
   * FYI –
   *    OLD HERMES PAX LOGIC – <No of Rooms>-<Adults in one room><Adults in Other Room>…
   *    NEW HERMES PAX LOGIC – <No of Roooms>-<Total Number of Adults>-<Total Number of Children>…
   */

  // const finalPax = pax || paxFromDescblock || replaceLastHyphenWithUnderScore(roomString);

  // if (!hasHouseRules && (!!hotelPolicyError || !hotelPolicyList.length)) {
  //   return null;
  // }

  // if (hotelDetails?.supressHouseRules) {
  //   return null;
  // }

  return (
    <S.PolicyStyledWrapper id={detailsNavigationIds.hotelPolicies}>
      {/* POLICY HEADER */}
      <S.PolicyHeaderStyled>
        <S.PolicyHeaderTextStyled>Property Policies</S.PolicyHeaderTextStyled>
        {/* to be check later */}
        {
          <S.TimingPolicyWrapper>
            <span>
              Check-in Time: <strong>{isAltAcco ? checkInTime : checkInTimeForNonAltAcco}</strong>{' '}
              {haveFlexibleCheckinRules && '**'}
            </span>
            <span>
              Check-out Time:{' '}
              <strong>{isAltAcco ? checkoutTime : checkOutTimeForNonAltAcco}</strong>
            </span>
          </S.TimingPolicyWrapper>
        }
      </S.PolicyHeaderStyled>

      {/* POLICY BLOCK */}
      <BaseColumnWrap>
        {/* LOADER */}
        {searchRoomRequestState?.loading && (
          <S.PolicyListItemTextStyled>Loading Property Policy…</S.PolicyListItemTextStyled>
        )}

        {/* House Rules that contains Hotel Policies and a modal */}

        {hotelDetails?.supressHouseRules ? (
          <S.PolicyListItemTextStyled padding={'10px 20px'}>
            {hotelRulesDisclaimer}
          </S.PolicyListItemTextStyled>
        ) : (
          <HouseRules />
        )}

        {/* 🐨 ENHANCEMENT:
          1. provide a retry button
          2. handle error.message. Need to ask
            from hotel policy api maintainers for
            different errors they throw

            NOTE: because 2. is not done, we are
            showing a very generic error message
        */}

        {/* ERROR */}
        {/* {!hasHouseRules && (
          <S.ErrorText>An Error Occured While Loading Property Policies</S.ErrorText>
        )} */}
      </BaseColumnWrap>
    </S.PolicyStyledWrapper>
  );
};

export default Policy;
